var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-n5"},[_c('v-checkbox',{staticClass:"opt-in-checkbox",scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":function($event){$event.stopPropagation();return (() => {
            _vm.optIn === _vm.optIn;
          }).apply(null, arguments)}}})]},proxy:true}]),model:{value:(_vm.optIn),callback:function ($$v) {_vm.optIn=$$v},expression:"optIn"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }